var map = {
	"./AvenirNextLTPro-MediumCn.woff": 375,
	"./DINNextLTW23-Bold.woff": 376,
	"./Heebo-Medium.woff": 377,
	"./SFProText-Regular.woff": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 239;